import { Permissions } from "@cnx/common";
import api from "services/public/api";

class AuthService {
  static signup = async (identity: string) => {
    return api.post<{
      useRights: Permissions[];
      token: string;
      id: string;
      avatar: string;
      fullName: string;
    }>("/signup", {
      identity,
    });
  };
}

export default AuthService;
